module.exports = __webpack_public_path__ + "media/laptop_de.f19eb9cf.mp4";